import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { BREAKPOINTS } from '@hookdeck/theme';
import { OutpostDestination } from '../../../../../../../typings/outpost';
import Button from '../../../common/base/Button';
import Container from '../../../common/base/Container';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import useViewportBreakpoint from '../../../hooks/useViewportBreakpoint';
import MetricChart from '../Metrics/MetricChart';
import MetricTableChart from '../Metrics/MetricTableChart';
import MetricDatePicker, { useDateRange } from '../../DashboardScene/Metrics/MetricDatePicker';
import ChartInteractionGroup from '../../../common/Chart/ChartInteractionGroup';
const columns_for_breakpoints: Record<keyof typeof BREAKPOINTS, number> = {
  mobile: 1,
  tablet: 2,
  laptop: 2,
  desktop: 3
};
export const DestinationMetrics: React.FC<{
  destination: OutpostDestination;
}> = t0 => {
  const $ = _c(70);
  const {
    destination
  } = t0;
  const theme = useTheme();
  const breakpoint = useViewportBreakpoint();
  const [date_range, onDateRangeChanged] = useDateRange();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Date.now();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [refresh_key, setRefreshKey] = useState(t1);
  let t2;
  if ($[1] !== theme) {
    t2 = dimension => {
      const code = parseInt(dimension, 10);
      if (code >= 200 && code < 300) {
        return theme.colors.surface.chart.success;
      }
      if (code >= 300 && code < 400) {
        return theme.colors.on.neutral.warning;
      }
      if (code >= 400) {
        return theme.colors.surface.chart.danger;
      }
    };
    $[1] = theme;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getStatusCodeColor = t2;
  const is_webhook = destination.type === "webhook";
  let t3;
  if ($[3] !== destination.id) {
    t3 = {
      destination_id: destination.id
    };
    $[3] = destination.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const common_filters = t3;
  let t4;
  if ($[5] !== onDateRangeChanged) {
    t4 = range => onDateRangeChanged({
      relative: undefined,
      min: range.min,
      max: range.max
    });
    $[5] = onDateRangeChanged;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      b: 8
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      justify: "space-between",
      align: "center"
    };
    t7 = {
      t: 5.5,
      b: 4
    };
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text as="h2" size="l" bold={true} m={0} flex={{
      align: "center"
    }}>Metrics</Text>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      gap: 3
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== date_range || $[13] !== onDateRangeChanged) {
    t10 = <MetricDatePicker date_range={date_range} onDateRangeChanged={onDateRangeChanged} />;
    $[12] = date_range;
    $[13] = onDateRangeChanged;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Button outline={true} icon="reload" onClick={() => setRefreshKey(Date.now())}>Reload</Button>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10) {
    t12 = <Div flex={t6} m={t7}>{t8}<Div flex={t9}>{t10}{t11}</Div></Div>;
    $[16] = t10;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = columns_for_breakpoints[breakpoint] >= 2 ? 2 : 1;
  let t14;
  if ($[18] !== t13) {
    t14 = {
      columns: t13,
      gap: 6
    };
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      b: 6
    };
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = ["count"];
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== common_filters) {
    t17 = {
      ...common_filters,
      attempt_number: "1",
      manual: "false"
    };
    $[22] = common_filters;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== date_range || $[25] !== refresh_key || $[26] !== t17) {
    t18 = <MetricChart title="Events" chart_type="bar" metric_type="count" endpoint="attempts" measures={t16} value_key="Attempts.count" time_key="Attempts.createdAt" tooltip_label="Events" filters={t17} date_range={date_range} refresh_key={refresh_key} />;
    $[24] = date_range;
    $[25] = refresh_key;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = ["successful_count", "failed_count"];
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [{
      key: "successful_count",
      label: "Successful",
      theme_color: "success"
    }, {
      key: "failed_count",
      label: "Failed",
      theme_color: "danger"
    }];
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== common_filters || $[31] !== date_range || $[32] !== refresh_key) {
    t21 = <MetricChart title="Event deliveries" chart_type="bar" metric_type="count" endpoint="attempts" measures={t19} value_key="Attempts.successful_count" time_key="Attempts.createdAt" tooltip_label="Deliveries" filters={common_filters} series={t20} datasets_type="stacked" date_range={date_range} refresh_key={refresh_key} />;
    $[30] = common_filters;
    $[31] = date_range;
    $[32] = refresh_key;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== t14 || $[35] !== t18 || $[36] !== t21) {
    t22 = <Div grid={t14} m={t15}>{t18}{t21}</Div>;
    $[34] = t14;
    $[35] = t18;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  const t23 = columns_for_breakpoints[breakpoint] >= 3 ? 3 : columns_for_breakpoints[breakpoint];
  let t24;
  if ($[38] !== t23) {
    t24 = {
      columns: t23,
      gap: 6
    };
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      b: 20
    };
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = ["error_rate"];
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== common_filters || $[43] !== date_range || $[44] !== refresh_key) {
    t27 = <MetricChart title="Error rate" chart_type="line" metric_type="percent" endpoint="attempts" measures={t26} value_key="Attempts.error_rate" time_key="Attempts.createdAt" tooltip_label="Error rate" theme_color="danger" filters={common_filters} height={260} date_range={date_range} refresh_key={refresh_key} />;
    $[42] = common_filters;
    $[43] = date_range;
    $[44] = refresh_key;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] !== common_filters || $[47] !== date_range || $[48] !== getStatusCodeColor || $[49] !== is_webhook || $[50] !== refresh_key) {
    t28 = is_webhook && <MetricTableChart title="Events by status code" endpoint="attempts" measures={["count"]} dimensions={["code"]} filters={common_filters} date_range={date_range} refresh_key={refresh_key} get_color={getStatusCodeColor} />;
    $[46] = common_filters;
    $[47] = date_range;
    $[48] = getStatusCodeColor;
    $[49] = is_webhook;
    $[50] = refresh_key;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  let t30;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = ["count", "error_rate"];
    t30 = ["topic"];
    $[52] = t29;
    $[53] = t30;
  } else {
    t29 = $[52];
    t30 = $[53];
  }
  let t31;
  if ($[54] !== common_filters || $[55] !== date_range || $[56] !== refresh_key) {
    t31 = <MetricTableChart title="Events by topic" endpoint="attempts" measures={t29} dimensions={t30} filters={common_filters} date_range={date_range} refresh_key={refresh_key} show_error_rate={true} />;
    $[54] = common_filters;
    $[55] = date_range;
    $[56] = refresh_key;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] !== t24 || $[59] !== t27 || $[60] !== t28 || $[61] !== t31) {
    t32 = <Div grid={t24} m={t25}>{t27}{t28}{t31}</Div>;
    $[58] = t24;
    $[59] = t27;
    $[60] = t28;
    $[61] = t31;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] !== t12 || $[64] !== t22 || $[65] !== t32) {
    t33 = <Container left={true} m={t5}>{t12}{t22}{t32}</Container>;
    $[63] = t12;
    $[64] = t22;
    $[65] = t32;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== t33 || $[68] !== t4) {
    t34 = <ChartInteractionGroup onTimeRangeSelected={t4}>{t33}</ChartInteractionGroup>;
    $[67] = t33;
    $[68] = t4;
    $[69] = t34;
  } else {
    t34 = $[69];
  }
  return t34;
};